
import { getSchema } from '../../decorators/utilities/get.merge.schema';
import { MergeField } from '../../decorators/decorators/merge.field';
import { MergeSchema } from '../../decorators/decorators/merge.schema';
import { ActivityEntityName } from '../../../../entities/shared/activity.entity.name';
import { Entity } from '../../../../entities/entity';

@MergeSchema({
    entity: ActivityEntityName.Site
})
export class SiteMergeData {
    @MergeField({
        displayName: 'Site Name'
    })
    name: string;

    @MergeField()
    fullAddress: string;

    @MergeField()
    phone: string;

    @MergeField()
    email: string;

    @MergeField({
        source: 'Reference (Place Id)'
    })
    placeId: string;

    customFields: any;
    manager: Entity;
    owner: Entity;
    contact: Entity;
    parent: Entity;
}

export const SiteMergeSchema = getSchema(SiteMergeData);